// ============================================
// Main Entry Point
// ============================================

import './styles/main.scss';
import { initApp } from './app';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
  initApp();
});
